document.addEventListener('DOMContentLoaded', function () {
    var npswiper = new Swiper('.np-sec3-swiper', {
        slidesPerView: 1,
        slidesPerGroup: 1,
        speed: 800,
        mousewheel: true,
        mousewheel: {
            releaseOnEdges: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        on: {
            slideChange: function () {
                $('.np-sec3-pi-d').removeClass('active');
                $('.np-sec3-btn-' + this.activeIndex).addClass('active');
            },
        },
    });
    $('.np-sec3-pi-d').click(function () {
        npswiper.slideTo($(this).data('index'), 800, false);
    });
});